import { Wallet } from 'lucide-react';
import { FC } from 'react';
import { CardState } from '../../types/cardState';
import { LightContractCard } from '../cards/LightContractCard';
import { useBorrowerRisk } from './useBorrowerRisk';

interface BorrowerRiskProps {
  isCardDisabled: boolean;
  status: CardState;
  onRefresh?: () => void;
}

export const BorrowerRisk: FC<BorrowerRiskProps> = ({
  isCardDisabled,
  status,
  onRefresh
}) => {
  const { openLoanDetailsPanel } = useBorrowerRisk(onRefresh);

  return (
    <LightContractCard
      icon={
        <div className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center bg-primary/10">
          <Wallet className="w-5 h-5 text-primary" />
        </div>
      }
      title="Les prêts"
      status={status}
      disabled={isCardDisabled}
      onClick={openLoanDetailsPanel}
    />
  );
};
